import React from 'react';
import WebBasic from 'views/WebBasic';

const WebBasicPage = () => {
  return <WebBasic />;
};

export default WebBasicPage;